import { ProductVariationModel } from '@simploshop-models/product-variation.model'

export default defineNuxtPlugin({
    name: 'model-customization',
    parallel: true,
    setup: () => {
        const runtimeConfig = useRuntimeConfig()


        const customerCreditsAccountId = Number(runtimeConfig.public.id.customerCreditsAccount)
        // CartModel
        CartModel.prototype.getRemainingCustomerCredits = function () {
            return this.customerAccountAmountsOfItems?.find(acc => acc.customer_account_id === customerCreditsAccountId)
                ?.amounts_remain ?? 0
        }

        CartModel.prototype.getCustomerCreditsToBeGained = function () {
            return this.customerAccountAmountsOfOrder?.find(acc => acc.customer_account_id === customerCreditsAccountId)
                ?.amounts ?? 0
        }

        CartModel.prototype.getRemainingCustomerCreditsValuation = function () {
            return this.customerAccountAmountsOfItems?.find(acc => acc.customer_account_id === customerCreditsAccountId)
                ?.converted_amounts_remain ?? null
        }

        CartModel.prototype.getCustomerCreditsToBeGainedValuation = function () {
            return this.customerAccountAmountsOfOrder?.find(acc => acc.customer_account_id === customerCreditsAccountId)
                ?.converted_amounts ?? null
        }


        // CustomerModel
        CustomerModel.prototype.getTotalCredits = function () {
            return this.customerAccountAmounts?.find(acc => acc.customerAccountId === customerCreditsAccountId)
                ?.amount ?? 0
        }

        CustomerModel.prototype.getTotalCreditsValuation = function () {
            return this.customerAccountAmounts?.find(acc => acc.customerAccountId === customerCreditsAccountId)
                ?.conversionValueWholeAccount ?? null
        }

        CustomerModel.prototype.getTotalCreditsReceived = function () {
            return this.customerAccountAmounts?.find(acc => acc.customerAccountId === customerCreditsAccountId)
                ?.receivedAmount ?? 0
        }

        CustomerModel.prototype.getTotalCreditsUsed = function () {
            return this.customerAccountAmounts?.find(acc => acc.customerAccountId === customerCreditsAccountId)
                ?.usedAmount ?? 0
        }

        CustomerModel.prototype.getTotalCreditsReceivedValuation = function () {
            return this.customerAccountAmounts?.find(acc => acc.customerAccountId === customerCreditsAccountId)
                ?.conversionValueReceivedAmount ?? null
        }

        CustomerModel.prototype.getTotalCreditsUsedValuation = function () {
            return this.customerAccountAmounts?.find(acc => acc.customerAccountId === customerCreditsAccountId)
                ?.conversionValueUsedAmount ?? null
        }

        // ProductModel
        ProductModel.prototype.canBePurchasedForCredits = function (variation?: ProductVariationModel | null) {
            if (!this.customerAccountProducts) return false

            if (!variation) {
                return this.customerAccountProducts?.some(product => product.can_use_credits && product.customer_account_id === customerCreditsAccountId) ?? false
            }

            return this.customerAccountProducts?.find(product => product.customer_account_id === customerCreditsAccountId && product.product_variation_id === variation.id)?.can_use_credits ?? false
        }

        ProductModel.prototype.getAmountOfCreditsForOrder = function (variation?: ProductVariationModel | null) {
            if (!this.customerAccountProducts) return null

            return this.customerAccountProducts?.find(product => product.product_variation_id === (variation?.id ?? null) && product.customer_account_id === customerCreditsAccountId)?.amount_from_order ?? null
        }

        // OrderItemModel
        OrderItemModel.prototype.getAmountOfCreditsUsed = function () {
            return this.customerAccount?.amount ?? null
        }
    },
})
